'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchSectionShell } from '../SearchSectionShell';
import { LocalMarketList } from './LocalMarketList';
import { SearchMarketCardSkeletonList } from './SearchMarketCardSkeleton';
interface LocalMarketSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
}
export function LocalMarketSearch(t0) {
  const $ = _c(16);
  const {
    keyword,
    page,
    onPageChange
  } = t0;
  let t1;
  if ($[0] !== keyword || $[1] !== page) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/local-market"]({
      query: {
        searchKeyword: keyword,
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = keyword;
    $[1] = page;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount ?? 0;
  let t4;
  if ($[5] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const meta = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SearchSideAdBanner />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== data?.context?.contents || $[9] !== isLoading) {
    t6 = isLoading ? <SearchMarketCardSkeletonList count={PAGE_SIZE} /> : <LocalMarketList items={data?.context?.contents ?? []} />;
    $[8] = data?.context?.contents;
    $[9] = isLoading;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== meta || $[12] !== onPageChange || $[13] !== page || $[14] !== t6) {
    t7 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" rightAside={t5}><SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t6}</SearchSectionShell></DesktopPageShell>;
    $[11] = meta;
    $[12] = onPageChange;
    $[13] = page;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}